import React, { Component } from "react";
import ComingUp from "../ComingUp";
export default class Level_3 extends Component {
  render() {
    return (
      <div>
        <ComingUp />
      </div>
    );
  }
}
